module.exports = __webpack_public_path__ + "img/section3.a912377b.jpg";